import { render } from "./Progetti.vue?vue&type=template&id=590d3ab5&scoped=true&ts=true"
import script from "./Progetti.vue?vue&type=script&lang=ts"
export * from "./Progetti.vue?vue&type=script&lang=ts"

import "./Progetti.vue?vue&type=style&index=0&id=590d3ab5&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_seilatv/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590d3ab5"]])

export default __exports__